import React, { useCallback, useEffect, useState } from 'react';
import NoResultsForFiltersMessage from '../no-results-for-filters-message';
import { Box, Card, Flex, Image, List, Button, Heading, ListItem, Text, useBreakpointValue, } from '@spothero/ui';
import Link from 'router/Link';
import trackErrorMessageDisplayed from 'segment/events/error-message-displayed';
import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { useNoResultsSegmentProperties } from './hooks/useNoResultsSegmentProperties';
import { useNoResultsGetCities } from './hooks/useNoResultsGetCities';
import { selectSearchLatLon, selectSearchRequest, selectSearchRequestLatLon, } from './selectors/noResultsSelectors';
import { RETURN_MAP_TO_CENTER_EVENT } from 'utils/window-events/constants';
const listItemStyles = {
    listStylePosition: 'outside',
    marginY: 2,
};
const SpotListNoResults = ({ numFilters, onResetFiltersClick, close = () => '', }) => {
    const isMobile = useBreakpointValue({ base: true, tablet: false });
    const [cities, setCities] = useState([]);
    const [apiErrorMsg, setApiErrorMsg] = useState('');
    const { monthly, starts, ends, timezone, operator_id } = useSelector(selectSearchRequest);
    const isFilteringByOperator = Boolean(operator_id);
    const segmentProperties = useNoResultsSegmentProperties(numFilters);
    const searchState = useSelector(selectSearchLatLon);
    const searchRequestState = useSelector(selectSearchRequestLatLon);
    const ContainerComponent = isMobile ? Box : Card;
    // Confirm searchState exists then check equality
    const showButton = searchState.latitude && !isEqual(searchState, searchRequestState);
    const onClick = useCallback(() => {
        // Event corresponds to google-map-widget
        const returnToCenterEvent = new Event(RETURN_MAP_TO_CENTER_EVENT);
        window.dispatchEvent(returnToCenterEvent);
        close();
    }, [close]);
    useEffect(() => {
        trackErrorMessageDisplayed(segmentProperties);
    }, [segmentProperties]);
    useEffect(() => {
        let mounted = true;
        // TODO: Fix the rules of hooks error
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useNoResultsGetCities({
            mounted,
            setCities,
            setApiErrorMsg,
            reduxState: {
                monthly,
                starts,
                ends,
                timezone,
                searchState,
                searchRequestState,
            },
        });
        return () => {
            mounted = false;
        };
    }, [searchState, searchRequestState, monthly, starts, ends, timezone]);
    if (numFilters > 0) {
        return (<NoResultsForFiltersMessage onResetFiltersClick={onResetFiltersClick}/>);
    }
    return (<ContainerComponent data-testid="SpotListNoResults" backgroundColor="white" paddingTop={4}>
            <Flex justifyContent="center">
                <Image src="/img/search/spothero-magnifying-glass.svg" alt="Magnifying glass"/>
            </Flex>

            <Box padding={2} textAlign="center">
                <Heading variant="h5" paddingY={2}>
                    No results in this area
                </Heading>

                <Text variant="body2" paddingBottom={2}>
                    {isFilteringByOperator
            ? 'To see available parking, try selecting a different location or time'
            : 'To see available parking, you can try running a search again or explore options in the closest city to you'}
                </Text>
                {showButton && (<Button marginY="2" textTransform="initial" onClick={onClick} data-testid="SpotListNoResults-button">
                        Return to Original Search
                    </Button>)}

                {!isFilteringByOperator && (<>
                        <Heading variant="h6" marginTop="4" marginBottom="2">
                            Closest Cities:
                        </Heading>

                        <List type="unstyled" marginBottom={isMobile ? '10' : '0'} minHeight="14">
                            {cities?.map((city, index) => (<ListItem sx={listItemStyles} key={city.id}>
                                    <Link forceAnchor data-testid={`SpotListNoResults-link-${index}`} to={city?.cityUrl}>
                                        {city.title}
                                    </Link>
                                </ListItem>))}
                            {apiErrorMsg && (<ListItem sx={listItemStyles}>
                                    <Text>{apiErrorMsg}</Text>
                                </ListItem>)}
                        </List>
                    </>)}
            </Box>
        </ContainerComponent>);
};
export default SpotListNoResults;
